/**
 * Contact form — on successful CF7 submit, replace the form with a custom
 * success box. Errors keep using the default CF7 output.
 */
export function contactForm() {
  document.addEventListener('wpcf7mailsent', ( event ) => {
    const scope = event.target.closest('.section-contact__form');
    if ( ! scope ) {
      return;
    }

    const form = scope.querySelector('.wpcf7');
    const success = scope.querySelector('.form-success');

    if ( form ) {
      form.style.display = 'none';
    }
    if ( success ) {
      success.hidden = false;
    }
  } );
}
